"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _Visiting = _interopRequireDefault(require("./components/Visiting.vue"));
var _VisitPlan = _interopRequireDefault(require("./components/VisitPlan.vue"));
var _CustomerDistribution = _interopRequireDefault(require("./components/CustomerDistribution.vue"));
var _NetworkExpansion = _interopRequireDefault(require("./components/NetworkExpansion.vue"));
var _comment = _interopRequireDefault(require("@/views/dashboard/components/comment.vue"));
var _AssignTasks = _interopRequireDefault(require("@/components/AssignTasks"));
var _index = require("@/utils/index");
var _storage = require("@/utils/storage");
var _homeReport = require("@/http/interface/sfe/homeReport");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Visiting: _Visiting.default,
    VisitPlan: _VisitPlan.default,
    CustomerDistribution: _CustomerDistribution.default,
    NetworkExpansion: _NetworkExpansion.default,
    Commment: _comment.default,
    AssignTasks: _AssignTasks.default
  },
  data: function data() {
    return {
      isLoading: false,
      loadingComponent: null,
      activeName: "visiting",
      RSMList: [],
      showCommentDialog: false,
      currentRow: {},
      exportUrl: {
        visiting: "/protected/cp/report/visitRetailorMonthly/export",
        visitPlan: "/protected/cp/report/planTaskWeekly/export",
        customerDistribution: "/protected/cp/report/customerDistribution/export",
        networkExpansion: "/protected/cp/report/expansionStore/export"
      }
    };
  },
  computed: {
    // 当前用户角色
    userRole: function userRole() {
      return this.$store.getters.roles[0];
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0)"
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    activeName: {
      handler: function handler(newValue) {
        var type;
        switch (newValue) {
          case "visiting":
            type = "visiting";
            break;
          case "visitPlan":
            type = "visitPlan";
            break;
          case "customerDistribution":
            type = "customerDistribution";
            break;
          case "networkExpansion":
            type = "networkExpansion";
            break;
          default:
            break;
        }
        // this.$api.CPPerformanceReport.setLog({ performanceType: type });
      },
      immediate: true
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      console.log(from);
      if (from.name === 'SrDetails' && _storage.SessionStorage.isItemExist('activeName')) {
        vm.activeName = _storage.SessionStorage.getItem('activeName');
        var refString = vm.activeName + "Ref";
        var cacheSearchVal = _storage.SessionStorage.getItem('searchData');
        vm.$refs[refString].searchData(cacheSearchVal);
        _storage.SessionStorage.removeItem('activeName');
        _storage.SessionStorage.removeItem('searchData');
      } else {
        var _refString = vm.activeName + "Ref";
        vm.$refs[_refString].searchData();
      }
    });
  },
  mounted: function mounted() {
    this.getRSMList();
  },
  methods: {
    getRSMList: function getRSMList() {
      var _this = this;
      this.$api.CPPerformanceReport.getRsmList().then(function (res) {
        _this.RSMList = res.data;
      });
    },
    handleClick: function handleClick(elTab) {
      var ref = elTab.$children[0];
      ref.searchData();
    },
    addCommentByRow: function addCommentByRow(row, apiKey, rowKey) {
      var _this2 = this;
      console.log(row, apiKey, rowKey);
      var params = (0, _defineProperty2.default)({}, apiKey, row[rowKey] || "");
      (0, _homeReport.getCommentOrgBiz)(params).then(function (res) {
        _this2.currentRow = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          orgBiz: res.data || [],
          params: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
            dateType: "0",
            dateValue: "0"
          })
        });
      });
      this.showCommentDialog = true;
    },
    submitCommentDialog: function submitCommentDialog(form) {
      this.submitCommentByRow(form);
    },
    submitCommentByRow: function submitCommentByRow(form) {
      var _this3 = this;
      var empNoList = [].concat((0, _toConsumableArray2.default)(form.asm), (0, _toConsumableArray2.default)(form.sr));
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        empNoList: empNoList
      });
      (0, _homeReport.getCommentSendSingle)(params).then(function (res) {
        _this3.$message.success(_this3.$t("dashboard.commentSuccess"));
        _this3.closeCommentDialog();
      });
    },
    closeCommentDialog: function closeCommentDialog() {
      this.showCommentDialog = false;
      this.currentRow = {};
    },
    assignTasks: function assignTasks(SRInfo, type) {
      this.$refs.AssignTasks.showModel(SRInfo, type);
    },
    exportReport: function exportReport(param) {
      var _this4 = this;
      if (this.isLoading) return;
      this.isLoading = true;
      var promiseFn = this.$api.CPPerformanceReport.exportReportFile;
      var fileName = this.$t("sfe.CPPerformanceReport.tab.".concat(this.activeName));
      promiseFn(this.exportUrl[this.activeName], param).then(function (res) {
        _this4.isLoading = false;
        (0, _index.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this4.isLoading = false;
      });
    }
  }
};